import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Nosotros() {
  return (
    <>
      <Helmet>
        <title>Belu Tours</title>
        <meta
          name="description"
          content="Conoce a Belén Villarroel Villarroel, la fundadora de Belu Tours. Más de 15 años de experiencia en turismo y un sueño cumplido: crear una agencia de viajes personalizada."
        />
        <link rel="canonical" href="https://belutoursviajesyturismo.tur.ar/nosotros" />
      </Helmet>

<section id="nosotros" aria-labelledby="nosotros-title" className="scroll-mt-28 bg-[#fffaf3] py-8 md:py-16 px-4">
        <div className="max-w-screen-xl mx-auto grid md:grid-cols-2 gap-10 items-center">

          {/* Modo mobile: solo una imagen visible + texto */}
          <div className="block md:hidden text-center relative">
            <span className="inline-block mb-4 px-4 py-1.5 text-lg font-semibold uppercase tracking-wide text-white bg-[#B49A56] rounded-full shadow">
              New York
            </span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/belu1.webp`}
              alt="Belu en acción"
              loading="lazy"
              className="mx-auto w-40 object-cover rounded-lg border-4 border-[#B49A56] shadow-md mb-6"
              style={{ aspectRatio: '4 / 5' }}
            />
            <h2 id="nosotros-title" className="text-3xl font-bold text-[#B49A56] mb-4 text-center">CONOCÉ BELU TOURS</h2>
            <p className="text-base text-gray-700 leading-relaxed text-justify mb-6 px-4">
              Hola, soy Belén Villarroel Villarroel, Técnica Superior en Turismo egresada de la Escuela Internacional de Turismo, Hotelería y Gastronomía de Mendoza.
              Cuento con más de 15 años de experiencia y estoy habilitada como idónea.
              <br /><br />
              En 2024 decidí cumplir un gran sueño: crear mi propia agencia de viajes. Así nació <strong>Belu Tours</strong>, un proyecto que refleja mi pasión por descubrir el mundo y ayudar a otros a vivirlo a su manera.
              <br /><br />
              Mi misión es diseñar viajes que se ajusten a cada persona. <br />
              Mi visión: que cada cliente vuelva con el corazón lleno y recuerdos imborrables.
            </p>
            <div className="mt-4 text-center">
              <a
                href="#contacto"
                className="bg-[#B49A56] text-white px-6 py-3 rounded-lg hover:bg-[#9e844f] transition-colors duration-300 focus:outline-none focus:ring focus:ring-[#B49A56]"
              >
                Contáctanos ahora
              </a>
            </div>
          </div>

          {/* Modo desktop: collage */}
          <div className="hidden md:flex relative justify-center items-center h-[500px]">
            <span className="absolute -top-14 left-1/2 -translate-x-1/2 px-6 py-2 text-2xl font-bold uppercase tracking-wide text-white bg-[#B49A56] rounded-full shadow z-40">
              New York
            </span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/belu1.webp`}
              alt="Belu en acción"
              loading="lazy"
              className="absolute w-64 object-cover rounded-lg border-4 border-[#B49A56] shadow-lg rotate-2 animate-caer1 transition-all duration-500 hover:scale-110 hover:-translate-y-4 hover:z-30 hover:shadow-2xl"
              style={{ top: '0', left: '0', aspectRatio: '4 / 5' }}
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/belu2.webp`}
              alt="Belu viajando"
              loading="lazy"
              className="absolute w-64 object-cover rounded-lg border-4 border-[#B49A56] shadow-lg -rotate-3 animate-caer2 transition-all duration-500 hover:scale-110 hover:-translate-y-4 hover:z-30 hover:shadow-2xl"
              style={{ top: '100px', left: '180px', aspectRatio: '4 / 5' }}
            />
            <img
              src={`${process.env.PUBLIC_URL}/assets/belu3.webp`}
              alt="Belu presentando"
              loading="lazy"
              className="absolute w-64 object-cover rounded-lg border-4 border-[#B49A56] shadow-md rotate-1 animate-caer3 transition-all duration-500 hover:scale-110 hover:-translate-y-4 hover:z-30 hover:shadow-2xl"
              style={{ top: '200px', left: '80px', aspectRatio: '4 / 5' }}
            />
          </div>

          {/* Texto desktop */}
          <div className="text-gray-700 text-base leading-relaxed relative hidden md:block">
            <h2 id="nosotros-title" className="text-3xl font-bold text-[#B49A56] mb-6 text-center">CONOCÉ BELU TOURS</h2>
            <p className="text-lg leading-relaxed text-justify">
              Hola, soy Belén Villarroel Villarroel, Técnica Superior en Turismo egresada de la Escuela Internacional de Turismo, Hotelería y Gastronomía de Mendoza.
              Cuento con más de 15 años de experiencia y estoy habilitada como idónea.
              <br /><br />
              En 2024 decidí cumplir un gran sueño: crear mi propia agencia de viajes. Así nació <strong>Belu Tours</strong>, un proyecto que refleja mi pasión por descubrir el mundo y ayudar a otros a vivirlo a su manera.
              <br /><br />
              Mi misión es diseñar viajes que se ajusten a cada persona. <br />
              Mi visión: que cada cliente vuelva con el corazón lleno y recuerdos imborrables.
            </p>
            <div className="mt-8 text-center">
              <a
                href="#contacto"
                className="bg-[#B49A56] text-white px-6 py-3 rounded-lg hover:bg-[#9e844f] transition-colors duration-300 focus:outline-none focus:ring focus:ring-[#B49A56]"
              >
                Contáctanos ahora
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
